import { Box, useTheme } from "@mui/material"
import SHQuickAction from "../../../../components/theme/Modal/SHQuickAction"
import { ProductHoverDetails } from "../orders/OrdersEcheckView2"
import Text from "../../../../components/theme/text/Text"
import { useTranslation } from "react-i18next"
import { tokens } from "../../../../theme"
import cx from 'classnames';
import { echeck_scan_option, orderline_type, warehouselocationtype_type } from "../../../../utils/staticEnums"
import ShLabel from "../../../../components/theme/label/ShLabel"
import { getWarehouseLocationLabelData } from "../../../../utils/labelColorText"
import { toast } from "react-toastify"
import { getPickingLocations, getProductValidation, getVirtualProductNames } from "../helper"
import { booleanValueTypes } from "../../../../components/Streams/Conditions/ConditionSettings"

export const ToScanProductRow = ({index,setChosenProductForSerial,serialNumberData,row,setMatchedProduct,hasClickToScanPermission,viewStocksInOrderProcessing,viewPickingLinesInOrderProcessing,setHighlightColor,clickAllProducts}) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const pickingLocations = viewPickingLinesInOrderProcessing ? getPickingLocations(row) : [];

    const toBoolean = value => {
        if (value === true || value === false) return value;      // already boolean
        if (value === "true") return true;
        if (value === "false") return false;
        return Boolean(value); // fallback for other cases
    };

    return (
        <SHQuickAction
            key={index}
            component={<ProductHoverDetails productId={row.product.id} product={row.product}/>}
            anchorOrigin={{
                vertical:'center',
                horizontal:"right"
            }}
            transformOrigin={{
                vertical:'center',
                horizontal:"left"
            }}
            sx={{
                modal:{
                    body:{
                        ml:2,
                        "@media screen and (max-width: 47.9375em)" : {
                            ml:0,
                        }
                        
                    }
                }
                // ml:1.5,
            }}
            disableAutoFocus
            disableEnforceFocus
        >
            {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                <Box
                    className={cx('', {
                        'is-addon' : row.type === orderline_type.ADD_ON,
                        'is-serialnumber': row.serialnumbers?.length > 0,
                    })}
                    onClick={() => {
                        const validation = getProductValidation(row.product);

                        if(validation === echeck_scan_option.NEVER_SCAN) {
                            // never_scan: always allow clicking
                            if (row.serialnumbers?.length > 0) {
                                setChosenProductForSerial(row);
                                serialNumberData.setOpen(true);
                            } else {
                                setMatchedProduct(row);
                            }
                        } else if(validation === echeck_scan_option.ALWAYS_SCAN) {
                            // always_scan: cannot click unless add_on or clickAllProducts overrides
                            if(clickAllProducts || row.type === orderline_type.ADD_ON) {
                                if (row.serialnumbers?.length > 0) {
                                    setChosenProductForSerial(row);
                                    serialNumberData.setOpen(true);
                                } else {
                                    setMatchedProduct(row);
                                }
                            } else {
                                setHighlightColor("orange");
                                toast.warn(t("please_scan_item"), {
                                    position: "bottom-left",
                                    autoClose: 2500,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    theme: "light",
                                });
                            }
                        } else {
                            // null / default: keep current behavior
                            if(hasClickToScanPermission || clickAllProducts){
                                if (row.serialnumbers?.length > 0) {
                                    setChosenProductForSerial(row);
                                    serialNumberData.setOpen(true);
                                } else {
                                    setMatchedProduct(row);
                                }
                            } else {
                                if(row.type === orderline_type.ADD_ON){
                                    setMatchedProduct(row);
                                } else if (row.serialnumbers?.length > 0) {
                                    setChosenProductForSerial(row);
                                    serialNumberData.setOpen(true);
                                } else {
                                    setHighlightColor("orange");
                                    toast.warn(t("please_scan_item"), {
                                        position: "bottom-left",
                                        autoClose: 2500,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        theme: "light",
                                    });
                                    
                                }
                                                                                
                            }
                        }
                    }}
                    aria-owns={anchorEl ? 'simple-popover' : undefined}
                    aria-haspopup="true"
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onTouchStart={onTouchStart} 
                    sx={{
                        mt:1,
                        flex:1,
                        display:"flex",
                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                        boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.15)" : null,
                        borderRadius:3,
                        padding:1,
                        alignItems:"center",
                        flexDirection:'column',
                        "&:hover": {
                            background: row.amountEchecked === row.amount ? colors.green[100] : colors.pink[100],
                        },
                        "&.is-serialnumber" : {
                            background:colors.pastel.light.lightblue[100],
                            border: `1px solid ${colors.pastel.light.lightblue[200]}`
                        },
                        "&.is-addon": {
                            background:colors.pastel.light.orange[100],
                            border: `1px solid ${colors.pastel.light.orange[200]}`
                        }
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            
                            width:1,
                        }}
                    >
                        <Box
                            sx={{
                                height:32,
                                px:1.5,
                                background:row.type !== orderline_type.ADD_ON ? colors.orange['100'] : colors.pastel.light.orange[200],
                                color:row.type !== orderline_type.ADD_ON ? colors.orange['400'] : colors.pastel.light.orange[600],
                                border: `1px solid ${row.type !== orderline_type.ADD_ON ? colors.orange[400] : colors.pastel.light.orange[600]}`,
                                // color:colors.pastel.light.orange[100],
                                borderRadius:4,
                                lineHeight:"32px",
                                fontWeight:500,
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                            }}
                        >
                            {row.amount}

                        </Box>
                        <Box
                            sx={{
                                ml:2,
                                display:"flex",
                                flexDirection:'column',
                            }}
                        >
                            <Text
                                sx={{
                                    whiteSpace:"pre",
                                    userSelect: "none",
                                    color:row.type !== orderline_type.ADD_ON ? colors.txt["primary"] : theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt['primary']
                                }} 
                                bold
                            >
                                {row.product.barcode}
                            </Text>
                            <Text
                                sx={{

                                    color:row.type !== orderline_type.ADD_ON ? colors.txt["primary"] : theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt['primary']
                                }}
                            >
                                {row.product.description}
                            </Text>
                            {getVirtualProductNames(row).map(name => (
                                <ShLabel key={"vp"+name} size={24} fitted variant="purple" sx={{mt:0.5, alignSelf:"flex-start", height:"auto", minHeight:24, lineHeight:"18px", py:"2px", textAlign:"left"}}>
                                    {name}
                                </ShLabel>
                            ))}
                        </Box>
                        {row.serialnumbers?.length >0 &&
                            <Box
                                sx={{
                                    height:32,
                                    ml:"auto",
                                    px:1.5,
                                    mr:1,
                                    background:colors.pastel.light.lightblue[600],
                                    color:colors.pastel.light.lightblue[100],
                                    borderRadius:2,
                                    lineHeight:"32px",
                                    fontWeight:500,
                                    fontFamily:"Roboto, sans-serif",
                                    fontSize:14,
                                    my:"auto",
                                }}
                            >
                                {row.serialnumbers[0].barcode}
                            </Box>
                        }
                        {row.type === orderline_type.ADD_ON &&
                            <Box
                                sx={{
                                    height:32,
                                    ml:"auto",
                                    px:1.5,
                                    mr:1,
                                    background:colors.pastel.light.orange[600],
                                    color:colors.pastel.light.orange[100],
                                    borderRadius:2,
                                    lineHeight:"32px",
                                    fontWeight:500,
                                    fontFamily:"Roboto, sans-serif",
                                    fontSize:14,
                                    my:"auto",
                                }}
                            >
                                {t("add_on")}
                            </Box>
                        }
                    </Box>
                    {row.product?.productFieldValues?.some(
                        pfv => pfv.value !== null && pfv.value !== "" && pfv.value !== undefined &&
                            (!booleanValueTypes.includes(pfv.productfield.valueType) || toBoolean(pfv.value))
                    ) &&
                        <Box
                            sx={{
                                width:1,
                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[50],
                                display:'flex',
                                flexDirection:"column",
                                gap:1,
                                px:1.5,
                                py:1.5,
                                borderRadius:2,
                                mt:1.5,
                            }}
                        >
                            {row.product.productFieldValues
                                .filter(pfv =>
                                    pfv.value !== null &&
                                    pfv.value !== "" &&
                                    pfv.value !== undefined &&
                                    (!booleanValueTypes.includes(pfv.productfield.valueType) || toBoolean(pfv.value))
                                )
                                .map((pfv, pfvidex) => {
                                    return (
                                        booleanValueTypes.includes(pfv.productfield.valueType) ?
                                        <Box
                                            key={"pfv" + index + pfvidex}
                                            sx={{
                                                height:24,
                                                border:`1px solid ${toBoolean(pfv.value) ? colors.green[400] : colors.red[400]}`,
                                                background: toBoolean(pfv.value) ? colors.green[100] : colors.red[100],
                                                borderRadius:3,
                                                display:'flex',
                                                alignItems:"center",
                                                justifyContent:"space-between",
                                                px:1,
                                                "@media screen and (max-width: 47.9375em)" : {
                                                    flexWrap:"wrap",
                                                    height:"unset",
                                                    py:0.5,
                                                }
                                            }}
                                        >
                                            <Text>
                                                {pfv.productfield?.name}
                                            </Text>

                                            <Box
                                                sx={{
                                                    color: toBoolean(pfv.value) ? colors.green[400] : colors.red[400],
                                                    fontSize:14,
                                                    fontWeight:700,
                                                    fontFamily:"Roboto,sans-serif",
                                                    lineHeight:"16px",
                                                }}
                                            >
                                                {t(toBoolean(pfv.value) ? "yes" : 'no')}
                                            </Box>
                                        </Box>
                                        :
                                        <Box
                                            key={"pfv" + index + pfvidex}
                                            sx={{
                                                height:24,
                                                border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[200]}`,
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                                borderRadius:3,
                                                display:'flex',
                                                alignItems:"center",
                                                justifyContent:"space-between",
                                                px:1,
                                                "@media screen and (max-width: 47.9375em)" : {
                                                    flexWrap:"wrap",
                                                    height:"unset",
                                                    py:0.5,
                                                }
                                            }}
                                        >
                                            <Text>
                                                {pfv.productfield?.name}
                                            </Text>

                                            <Text>
                                                {pfv.value.toString()}
                                            </Text>
                                        </Box>
                                    )
                                })
                            }
                        </Box>
                    }
                    {viewStocksInOrderProcessing && row.product.stocks.filter(stock => stock.warehouseLocation.type === warehouselocationtype_type.GENERAL && stock.available > 0).length > 0 ?
                        <Box
                            sx={{
                                width:1,
                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[50],
                                display:'flex',
                                flexDirection:"column",
                                gap:1,
                                px:1.5,
                                py:1.5,
                                borderRadius:2,
                                mt:1.5,
                            }}
                        >
                            {row.product.stocks.filter(stock => stock.warehouseLocation.type === warehouselocationtype_type.GENERAL && stock.available > 0).sort((a,b) => (a.warehouseLocation?.location ?? "").localeCompare(b.warehouseLocation?.location ?? "", undefined, {numeric: true, sensitivity: "base"})).map((stock,idex) => {
                                const labelData = getWarehouseLocationLabelData(stock.warehouseLocation.type,theme)
                                return (
                                    <Box
                                        key={"location"+idex}
                                        sx={{
                                            width:1,
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                            display:"flex",
                                            height:32,
                                            alignItems:'center',
                                            pl:0.5,
                                            pr:0.5,
                                            borderRadius:4,
                                            border:theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                            boxShadow:theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                                        }}
                                    >

                                        <ShLabel
                                            borderless
                                            size={24}
                                            fitted
                                            variant={labelData.labelcolor}
                                            palette="normal"
                                            sx={{
                                                mr:1,
                                            }}
                                        >
                                            {t(labelData.labeltext)}
                                        </ShLabel>

                                        <Text>
                                            {stock.warehouseLocation.location}
                                        </Text>

                                        <ShLabel
                                            borderless
                                            size={24}
                                            fitted
                                            variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                            palette="normal"
                                            sx={{
                                                ml:"auto"
                                            }}
                                        >
                                            {stock.available + " "}
                                            <Text light>{t("available")}</Text>
                                        </ShLabel>
                                    </Box>
                                )}
                            )}
                        </Box>
                        :
                        viewStocksInOrderProcessing && row.type !== orderline_type.ADD_ON &&
                        <Box
                            sx={{
                                width:1,
                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[50],
                                display:'flex',
                                flexDirection:"column",
                                gap:1,
                                px:1.5,
                                py:1.5,
                                borderRadius:2,
                                mt:1.5,
                            }}
                        >
                            <Text>
                                {t("no_available_locations")}
                            </Text>
                        </Box>
                    }
                    {pickingLocations.length > 0 &&
                        <Box
                            sx={{
                                width:1,
                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[50],
                                display:'flex',
                                flexDirection:"column",
                                gap:1,
                                px:1.5,
                                py:1.5,
                                borderRadius:2,
                                mt:1.5,
                            }}
                        >
                            {pickingLocations.map((pickingLocation,pickingLocationIndex) => {
                                const labelData = getWarehouseLocationLabelData(pickingLocation.type,theme)
                                return (
                                    <Box
                                        key={"pickinglocation"+pickingLocationIndex}
                                        sx={{
                                            width:1,
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                            display:"flex",
                                            height:32,
                                            alignItems:'center',
                                            pl:0.5,
                                            pr:0.5,
                                            borderRadius:4,
                                            border:theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                            boxShadow:theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                                        }}
                                    >
                                        <ShLabel
                                            borderless
                                            size={24}
                                            fitted
                                            variant={labelData.labelcolor}
                                            palette="normal"
                                            sx={{
                                                mr:1,
                                            }}
                                        >
                                            {t(labelData.labeltext)}
                                        </ShLabel>

                                        <Text>
                                            {pickingLocation.location}
                                        </Text>

                                        <ShLabel
                                            borderless
                                            size={24}
                                            fitted
                                            variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                            palette="normal"
                                            sx={{
                                                ml:"auto"
                                            }}
                                        >
                                            {pickingLocation.amount}
                                        </ShLabel>
                                    </Box>
                                )}
                            )}
                        </Box>
                    }
                </Box>
            )}
        </SHQuickAction>
    )
}